(function () {
    if (location.protocol === 'http:' && window.location.hostname !== 'jbdev.benchmarkemail.com') {
        window.location = location.href.replace('http', 'https');
    }
})();

require('../less/styles.less');
require('../sass/main.scss');
require('../js/vendor/jquery-ui');
require('../js/vendor/time-picker.js');
require('../js/vendor/time-picker-slides.js');
require('angular-ui-bootstrap');
require('angular-cookies');

require('./controllers/modals');
require('./controllers');
require('./directives');
require('./services');

(function () {
    'use strict';

    angular
        .module('journeyBuilder', [
            'translateModule',
            'JB.translate.srv',
            'loginModule',
            'auth.srv',
            'ui.router',
            'homeModule',
            'canvasModule',
            'headerModule',
            'footerModule',
            'indexModule',
            'dataHandlingModule',
            'customDate',
            'faqModule',
            'summaryModule',
            'trackingReportsModule',
            'trackingCodeModule',
            'coachingModule',
            'upgradeModule',
            'ui.bootstrap',
            'entryModalModule',
            'reportModule'
        ])
        .config(['$stateProvider', '$urlRouterProvider', journeyRoute])
        .run(['$rootScope', '$state', 'AUTH_EVENTS', 'AuthSrv', '$stateParams', 'cacheService', accessControl])
        .run(['$rootScope', 'Translate', jbTranslate]);

    function journeyRoute($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('redirectcanvas', {
                url: "/redirectcanvas/:id",
                onEnter: ['$state', '$stateParams', function($state, $stateParams) {
                    window.location = window.location.origin + '/#/canvas/' + $stateParams.id;
                    setTimeout(() => {window.location.reload(true)}, 0);
                    document.getElementsByTagName('body')[0].classList.add('hide');
                }],
            })
            .state('home', {
                url: '/home',
                templateUrl: 'app/views/home.tpl.html',
                controller: 'homeCon',
                resolve: {
                    translate : ['$rootScope', function($rootScope) {
                        return $rootScope.translatePromise;
                    }]
                }
            })
            .state('canvas', {
                url: '/canvas',
                templateUrl: 'app/views/canvas.tpl.html',
                controller: 'canvasCon',
                resolve: {
                    translate : ['$rootScope', function($rootScope) {
                        return $rootScope.translatePromise;
                    }]
                }
            })
            .state('canvas/:canvasId', {
                url: '/canvas/:canvasId',
                templateUrl: 'app/views/canvas.tpl.html',
                controller: 'canvasCon',
                resolve: {
                    translate : ['$rootScope', function($rootScope) {
                        $rootScope.$emit('jbLoader', true);
                        return $rootScope.translatePromise;
                    }]
                }
            })
            .state('canvas/:canvasId/:emailId/:status', {
                url: '/canvas/:canvasId/:emailId/:status',
                templateUrl: 'app/views/canvas.tpl.html',
                controller: 'canvasCon',
                resolve: {
                    translate : ['$rootScope', function($rootScope) {
                        $rootScope.$emit('jbLoader', true);
                        return $rootScope.translatePromise;
                    }]
                }
            })
            .state('report/:canvasId', {
                url: '/report/:canvasId',
                controller: 'reportController',
                resolve: {
                    translate : ['$rootScope', function($rootScope) {
                        $rootScope.$emit('jbLoader', true);
                        return $rootScope.translatePromise;
                    }]
                }
            })
            .state("otherwise", {url: '/home'});

        $urlRouterProvider.otherwise('/home');

    }

    function accessControl($rootScope, $state, AUTH_EVENTS, AuthSrv, $stateParams, cacheService) {
        $rootScope.$on('$stateChangeStart', function (event, next, toParams) {

            if (next.name === 'home' && $stateParams.canvasId && $rootScope.jbToken && _notActive() && !_.isEqual($rootScope.currentJB, $rootScope.connections)) {
                if (window.confirm($rootScope.translate('common.back.message'))) {
                    $rootScope.$emit('pageLocationChanged', next);
                } else {
                    event.preventDefault();
                }
            } else {
                $rootScope.$emit('pageLocationChanged', next);
            }

            // if next route is home close the modal.
            if (next.name === 'home') {
                $rootScope.$emit('hideActionAddListModal');
                $rootScope.$emit('hideActionAddWaitTimeModal');
                $rootScope.$emit('hideActionRemoveListModal');
                $rootScope.$emit('hideActionSendEmailModal');
                $rootScope.$emit('hideConditionEmailEngagementtModal');
                $rootScope.$emit('hideConditionIfElseModal');
                $rootScope.$emit('hideConditionIsInListModal');
                $rootScope.$emit('hideConditionIsInSegmentModal');
                $rootScope.$emit('hideConditionIsNotInSegmentModal');
                $rootScope.$emit('hideConditionWebsiteActivityModal');
                $rootScope.$emit('hideEntryDateTimeModal');
                $rootScope.$emit('hideEntryEngagementModal');
                $rootScope.$emit('hideEntryListModal');
                $rootScope.$emit('hideEntrySegmentModal');
                $rootScope.$emit('hideReportsModal');
                $rootScope.$emit('hideFacebookAudienceModal');
            }

            //Check if user is logged in
            if ($rootScope.authCheckInProgress) return;

            event.preventDefault();
            $rootScope.authCheckInProgress = true;

            AuthSrv.isAuthenticated().then(function(isAuthenticated) {
                if (!isAuthenticated) {
                    $rootScope.authCheckInProgress = false;
                    window.location = AUTH_EVENTS.benchmarkLoginUrl;
                    return;
                }

                AuthSrv.getCurrentSession().then(function(session) {
                    var settingsData = sessionStorage.getItem('settingSession'),
                        settings = settingsData ? JSON.parse(settingsData) : {};

                    if (settingsData && settings.token === session.token) {
                        $rootScope.jbClient = settings.ClientId;
                        $rootScope.cSettings = settings;

                        //Intercom Script
                        if(settings.ClientId) {
                            window.intercomSettings = { app_id: "ilz8qnxk", user_id: settings.ClientId };
                        }

                        $state.go(next.name, toParams).then(function() {
                            $rootScope.authCheckInProgress = false;
                        });
                    } else {
                        cacheService.deleteCachable();

                        AuthSrv
                            .authUser(session.token).success(function(data) {
                                data.token = session.token;

                                //Cache session
                                if ($rootScope.localStorageSupported) {
                                    sessionStorage.setItem('settingSession', JSON.stringify(data));
                                }

                                $rootScope.jbClient = data.ClientId;
                                $rootScope.cSettings = data;

                                //Intercom Script
                                if(data.ClientId) {
                                    window.intercomSettings = { app_id: "ilz8qnxk", user_id: data.ClientId };
                                }

                                $state.go(next.name, toParams).then(function() {
                                    $rootScope.authCheckInProgress = false;
                                });

                            })
                            .error(function(error, status) {
                                console.log(error, status);
                                if (status === 401) {
                                    window.location = AUTH_EVENTS.benchmarkUi;
                                }else {
                                    Intercom('trackEvent', 'AP-ERROR-404', {
                                        description : 'Trigger this event whenever a user will be redirected to 404',
                                        metadata: {
                                            api: 'settings api',
                                            errStatus: status
                                        }
                                    });

                                    window.location = AUTH_EVENTS.maintenancePage;
                                }
                                AuthSrv.destroySession();
                                $rootScope.authCheckInProgress = false;
                                return;
                            })
                    }
                });
            });

            function _notActive() {
                return ($rootScope.currentJourneyStatus !== 3) &&
                       ($rootScope.currentJourneyStatus !== 4) &&
                       ($rootScope.currentJourneyStatus !== 8)
            }
        });

        let testKey = 'test', storage = window.sessionStorage;
        try
        {
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
            $rootScope.localStorageSupported = true;
        }
        catch (error)
        {
            $rootScope.localStorageSupported = false;
        }
    }

    function jbTranslate($rootScope, Translate) {
        $rootScope.$on('$stateChangeStart', function () {
            if (!$rootScope.translate) {
                Translate.buildDirectory();
            }
        });
    }
})();



// WEBPACK FOOTER //
// ./app/app.js